import styled from 'styled-components';
import WithDirection from '@iso/lib/helpers/rtl';

const ActivityWrapper = styled.div`
  width: 100%;
  height: 100vh;

  .button-group {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
  }
  
  .btn-success {
    background-color: #0B2A1B !important;
    border-color: #0B2A1B;
    height: 40px;
    max-width: 155px;
    border-radius: 8px;
    &:hover {
      opacity: 0.8;
    }
  }
  
  .search-bar {
    background: rgba(143, 146, 161, 0.05);
    border-radius: 12px;
    border: none;
    height: 40px;
    margin-left: 2rem;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    flex-direction: row-reverse;
    max-width: 228px;
  }
  
  .site-form-item-icon {
    height: 19px;
    width: 19px;
    color: #8F92A1;
    font-size: 19px;
  }
  
  .site-form-item-cancel {
    height: 15px;
    width: 15px;
    color: #8F92A1;
    font-size: 15px;
  }
  
  .search-bar .ant-input {
    background: none !important;
    border: none !important;
    color: #8F92A1;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
  }
  
  .manage-property-header {
    padding: 20px 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: auto;
    border-bottom: 1px solid #d9d9d9;
    margin-bottom: 24px; // Added spacing after header
  }

  .manage-property-title {
    font-family: "Inter";
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    color: #101828;
    margin: 0;
  }

  .mp-title {
    display: flex;
    align-items: center;
  }
  
  .ant-table-wrapper {
    min-width: 100%;
  }
  
  .fAgWDa .ant-table-content {
    overflow-x: unset;
  }
  
  .fAgWDa {
    overflow-x: unset;
  }
  
  .dtr-data {
    white-space: break-spaces;
  }
  
  .delete-button {
    margin-left: 8px;
  }
  
  .dataTables_filter {
    margin-bottom: 10px;
  }
  
  .dataTables_filter .input-sm {
    margin-left: 10px;
    text-align: center;
    outline-offset: unset;
    border-radius: 8px;
  }
  
  .action-button.view-history-button, 
  .action-button {
    margin-bottom: 5px;
  }

  .ant-spin-dot-item {
    background-color: #0B2A1B !important;
  }

  // Map specific styles
  .leaflet-container {
    height: 100%;
    width: 100%;
    border-radius: 16px !important;
  }

  .map-container {
    height: 75%;
    z-index: 50 !important;
    width: 100%;
    position: relative;
    margin-bottom: 24px; // Added spacing between map and device table
    border-radius: 12px; // Rounded container
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08); // Added shadow for depth

    .leaflet-map {
      height: 100%;
      width: 100%;
      border: 2px solid #d9d9d9;
      border-radius: 12px; // Made all corners rounded
    }

    .loading-overlay {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: rgba(255, 255, 255, 0.9);
      padding: 20px;
      border-radius: 8px;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
      z-index: 1000;
      display: flex;
      align-items: center;
      gap: 12px;
      font-family: "Inter";
      font-weight: 500;
      font-size: 14px;
      color: #101828;
    }

    // Map mode toggle with green theme
    .map-mode-toggle {
      .ant-radio-group {
        display: flex;
        
        .ant-radio-button-wrapper {
          background-color: #fff;
          border-color: #0B2A1B;
          color: #0B2A1B;
          font-weight: 500;
          font-size: 12px;
          height: 32px;
          display: flex;
          align-items: center;
          transition: all 0.3s ease;
          
          &:hover {
            background-color: rgba(11, 42, 27, 0.05);
            border-color: #0B2A1B;
            color: #0B2A1B;
          }
          
          &.ant-radio-button-wrapper-checked {
            background-color: #0B2A1B;
            border-color: #0B2A1B;
            color: #fff;
            box-shadow: -1px 0 0 0 #0B2A1B;
            
            &:hover {
              background-color: #0B2A1B;
              opacity: 0.9;
            }
            
            &::before {
              background-color: #0B2A1B;
            }
          }
          
          &:first-child {
            border-radius: 4px 0 0 4px;
            border-left-color: #0B2A1B;
          }
          
          &:last-child {
            border-radius: 0 4px 4px 0;
          }
          
          &:not(:first-child)::before {
            background-color: #0B2A1B;
          }
        }
      }
    }

    // Slider overlay styles
    .slider-overlay {
      position: absolute;
      bottom: 20px;
      right: 20px;
      width: 280px;
      background-color: rgba(255, 255, 255, 0.95);
      border-radius: 12px; // Made more rounded
      padding: 20px; // Increased padding
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15); // Enhanced shadow
      backdrop-filter: blur(8px);
      border: 1px solid rgba(255, 255, 255, 0.3);
      z-index: 1000;

      .slider-time-range {
        font-size: 11px;
        color: #666;
        font-weight: 500;
        margin-bottom: 12px;
        text-align: center;
      }

      .slider-time-labels {
        display: flex;
        justify-content: space-between;
        font-size: 10px;
        color: #888;
        margin-top: 8px;
      }

      // Custom slider styling with green theme
      .ant-slider {
        margin: 12px 0;
        
        .ant-slider-rail {
          background-color: #f0f0f0;
          height: 4px;
        }

        .ant-slider-track {
          background-color: #0B2A1B;
          height: 4px;
        }

        .ant-slider-handle {
          border-color: #0B2A1B;
          background-color: #fff;
          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
          width: 14px;
          height: 14px;

          &:hover {
            border-color: #0B2A1B;
          }

          &:focus {
            border-color: #0B2A1B;
            box-shadow: 0 0 0 2px rgba(11, 42, 27, 0.2);
          }
        }

        &:hover .ant-slider-track {
          background-color: #0B2A1B;
        }

        &:hover .ant-slider-handle:not(.ant-tooltip-open) {
          border-color: #0B2A1B;
        }
      }
    }
  }

  .device-selection {
    height: 25%;
    width: 100%;
    background-color: #fafafa;
    border: 2px solid #d9d9d9;
    border-radius: 12px; // Made device table container rounded
    overflow: hidden;
    display: flex;
    flex-direction: column;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08); // Added subtle shadow

    .device-header {
      background-color: #0B2A1B;
      color: white;
      padding: 18px 24px; // Increased padding
      font-weight: 600;
      font-size: 15px;
      font-family: "Inter";
      border-radius: 10px 10px 0 0; // Rounded top corners to match container
    }

    .device-table-container {
      flex: 1;
      overflow: hidden;
      padding: 16px;
      margin-bottom: 16px; // Added padding around table

      .ant-table {
        background-color: white;
        height: 100%;
        border-radius: 8px; // Rounded table
        overflow: hidden;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06); // Subtle table shadow
      }

      // Fixed table hover and selection styles with higher specificity
      .ant-table-wrapper .ant-table-tbody > tr:hover > td {
        background-color: rgba(11, 42, 27, 0.05) !important;
      }

      .ant-table-wrapper .ant-table-tbody > tr.ant-table-row-selected > td {
        background-color: rgba(11, 42, 27, 0.1) !important;
      }

      .ant-table-wrapper .ant-table-tbody > tr.ant-table-row-selected:hover > td {
        background-color: rgba(11, 42, 27, 0.15) !important;
      }

      // Remove blue selection colors completely
      .ant-table-wrapper .ant-table-tbody > tr.ant-table-row:hover > td,
      .ant-table-wrapper .ant-table-tbody > tr:hover:not(.ant-table-expanded-row) > td {
        background-color: rgba(11, 42, 27, 0.05) !important;
      }

      // Override any blue colors from Ant Design
      .ant-table-wrapper .ant-table .ant-table-tbody > tr.ant-table-row:hover > td,
      .ant-table-wrapper .ant-table-tbody tr:hover > td,
      .ant-table-wrapper .ant-table tr:hover > td {
        background-color: rgba(11, 42, 27, 0.05) !important;
      }

      .ant-btn-primary {
        background-color: #0B2A1B;
        border-color: #0B2A1B;
        border-radius: 8px;
        font-weight: 500;
        padding: 6px 16px;

        &:hover {
          background-color: #0B2A1B;
          border-color: #0B2A1B;
          opacity: 0.8;
        }

        &:focus {
          background-color: #0B2A1B;
          border-color: #0B2A1B;
        }
      }

      .ant-btn-default {
        border-color: #0B2A1B;
        color: #0B2A1B;
        border-radius: 8px;
        font-weight: 500;
        padding: 6px 16px;

        &:hover {
          border-color: #0B2A1B;
          color: #0B2A1B;
          opacity: 0.8;
        }
      }

      // Radio button styling to match green theme
      .ant-radio-wrapper {
        .ant-radio {
          .ant-radio-inner {
            border-color: #d9d9d9;
            
            &:hover {
              border-color: #0B2A1B;
            }
          }

          &.ant-radio-checked {
            .ant-radio-inner {
              border-color: #0B2A1B;
              background-color: #0B2A1B;

              &:after {
                background-color: #fff;
              }
            }
          }

          &:hover .ant-radio-inner {
            border-color: #0B2A1B;
          }
        }

        &:hover .ant-radio .ant-radio-inner {
          border-color: #0B2A1B;
        }
      }

      .ant-radio-group {
        width: 100%;
      }
    }
  }

  // Override default Ant Design styles to match Sensors theme
  .ant-select-selector {
    border-radius: 8px !important;
    border-color: #d9d9d9 !important;
    
    &:hover {
      border-color: #0B2A1B !important;
    }
  }

  .ant-select-focused .ant-select-selector {
    border-color: #0B2A1B !important;
    box-shadow: 0 0 0 2px rgba(11, 42, 27, 0.1) !important;
  }

  .ant-picker {
    border-radius: 8px !important;
    border-color: #d9d9d9 !important;
    
    &:hover {
      border-color: #0B2A1B !important;
    }
  }

  .ant-picker-focused {
    border-color: #0B2A1B !important;
    box-shadow: 0 0 0 2px rgba(11, 42, 27, 0.1) !important;
  }

  // Map control overrides
  .leaflet-control-zoom {
    margin-bottom: 35px !important;
    z-index: 100 !important;
    
    .leaflet-control-zoom-in,
    .leaflet-control-zoom-out {
      background-color: white;
      border: 1px solid #d9d9d9;
      color: #101828;
      z-index: 100 !important;
      
      &:hover {
        background-color: rgba(11, 42, 27, 0.05);
        border-color: #0B2A1B;
      }
    }
  }

  .leaflet-control-layers {
    .leaflet-control-layers-toggle {
      background-color: white;
      border: 1px solid #d9d9d9;
      
      
      &:hover {
        background-color: rgba(11, 42, 27, 0.05);
      }
    }
  }

  // Responsive design matching Sensors
  @media only screen and (max-width: 425px) {
    .search-bar {
      margin-left: 1rem;
    }
    
    .manage-property-header {
      padding: 20px 18px;
      flex-direction: column;
      align-items: flex-start;
      gap: 15px;
      margin-bottom: 20px; // Adjusted for mobile
    }

    .button-group {
      width: 100%;
      flex-wrap: wrap;
      gap: 10px;
    }

    .map-container {
      height: 60%;
      margin-bottom: 20px; // Adjusted for mobile

      .slider-overlay {
        width: calc(100% - 40px);
        right: 20px;
        left: 20px;
        padding: 16px; // Adjusted padding for mobile
      }

      .map-mode-toggle {
        left: 50%;
        right: auto;
        transform: translateX(-50%);
        bottom: 5px;
      }
    }

    .device-selection {
      height: 40%;
      
      .device-header {
        padding: 16px 20px; // Adjusted for mobile
      }
      
      .device-table-container {
        padding: 12px; // Adjusted for mobile
      }
    }
  }
  
  @media only screen and (max-width: 375px) {
    .manage-property-header {
      flex-wrap: wrap;
      padding: 20px 18px;
      margin-bottom: 16px; // Adjusted for smaller screens
    }
    
    .search-bar {
      margin-bottom: 10px;
      max-width: 100%;
      width: 100%;
      margin-left: 0rem;
    }
    
    .manage-property-header .button-group .btn-success {
      max-width: 100%;
      min-width: 100%;
    }
    
    .ant-card-body {
      padding: 24px 24px 0px 24px !important;
    }

    .button-group > * {
      flex: 1;
      min-width: 120px;
    }

    .map-container {
      margin-bottom: 16px; // Adjusted for smaller screens
      
      .slider-overlay {
        width: calc(100% - 20px);
        right: 10px;
        left: 10px;
        padding: 12px; // Smaller padding for very small screens
      }

      .map-mode-toggle {
        width: calc(100% - 20px);
        left: 10px;
        right: 10px;
        transform: none;
      }
    }

    .device-selection {
      .device-header {
        padding: 14px 18px; // Further adjusted for small screens
      }
      
      .device-table-container {
        padding: 10px; // Smaller padding for very small screens
      }
    }
  }

  // Additional responsive breakpoints for larger screens
  @media only screen and (width: 1440px),
         only screen and (width: 1024px),
         only screen and (width: 768px) {
    .map-container {
      height: 70vh;
      margin-bottom: 28px; // Larger spacing for bigger screens
    }

    .device-selection {
      height: calc(30vh - 80px);
    }
    
    .manage-property-header {
      margin-bottom: 28px; // Larger spacing for bigger screens
    }
  }
`;

export default WithDirection(ActivityWrapper);